import { VoicemailFiltersType } from '../../hooks/use-phone-config-state-store';
import { defaultDateRangeMap } from '../../utils';
import { MessageStatus } from '../all-calls/types';
import { DEFAULT_NO_TIME_PERIOD } from '../filter-selectors/time-period-selector';

export const createDefaultVoicemailFilters = (
  sipId?: string,
  overrides: Partial<VoicemailFiltersType> = {}
): VoicemailFiltersType => ({
  locationIds: overrides.locationIds ?? [],
  syncDeviceSipProfileId: overrides.syncDeviceSipProfileId ?? sipId,
  filterOptions: {
    callerNumber: overrides.filterOptions?.callerNumber ?? '',
    callerName: overrides.filterOptions?.callerName ?? '',
    endTime: overrides.filterOptions?.endTime ?? defaultDateRangeMap[DEFAULT_NO_TIME_PERIOD].endDate,
    startTime: overrides.filterOptions?.startTime ?? defaultDateRangeMap[DEFAULT_NO_TIME_PERIOD].startDate,
    status: overrides.filterOptions?.status ?? MessageStatus.MESSAGE_STATUS_ALL,
    mailboxIds: overrides.filterOptions?.mailboxIds ?? [],
    tagIds: overrides.filterOptions?.tagIds ?? [],
  },
});
